var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 57,
    viewBox: "0 0 8 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64644 56.3536C3.84171 56.5488 4.15829 56.5488 4.35355 56.3536L7.53553 53.1716C7.73079 52.9763 7.73079 52.6597 7.53553 52.4645C7.34027 52.2692 7.02369 52.2692 6.82842 52.4645L4 55.2929L1.17157 52.4645C0.976308 52.2692 0.659726 52.2692 0.464464 52.4645C0.269202 52.6597 0.269202 52.9763 0.464464 53.1716L3.64644 56.3536ZM3.5 -2.18557e-08L3.5 56L4.5 56L4.5 2.18557e-08L3.5 -2.18557e-08Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.07234fe31ba0f9fd188e919fb13792d9.svg";
export { ForwardRef as ReactComponent };